export default {
  plugins: [],
  loadingPlugins: false,
  loadingPluginsFailed: false,
  loadingPluginsSucceeded: false,
  loadingPluginsErrors: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/plugin/state.js